import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        CustomBreadcrumbModule: {
          module: () => import('./custom-breadcrumb.module').then((m) => m.CustomBreadcrumbModule),
          cmsComponents: ['BreadcrumbComponent'],
        },
      },
    }),
  ],
})
export class CustomBreadcrumLazybModule {}
